export const ATTRACTION_TYPE = 'attraction'
export const ACCOMMODATION_TYPE = 'accommodation'

export function determineItemType(types: Array<string> = []) {
  if (types.includes('lodging') && types.includes('establishment')) {
    return ACCOMMODATION_TYPE
  }
  return ATTRACTION_TYPE
}
